<template>
  <v-alert
    v-if="visible"
    color="amber-darken-2"
    variant="tonal"
    density="comfortable"
    class="premium-contest-banner"
  >
    <div class="premium-contest-banner__content">
      <div class="premium-contest-banner__icon-wrap" aria-hidden="true">
        <v-icon size="28" color="amber-darken-4">mdi-crown</v-icon>
      </div>

      <div class="premium-contest-banner__text">
        <div class="premium-contest-banner__title text-amber-darken-4">Sorteo Premium</div>
        <p class="premium-contest-banner__description mb-0">
          Participa por acceso anticipado y gratuito a Premium. Tienes hasta el 6 de septiembre.
        </p>
      </div>

      <div class="premium-contest-banner__actions">
        <v-btn color="amber-darken-4" variant="flat" size="small" @click="participate">
          Participar
        </v-btn>

        <v-btn color="amber-darken-4" variant="outlined" size="small" @click="dismiss">
          Cerrar
        </v-btn>
      </div>
    </div>
  </v-alert>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue'

import {
  isPremiumContestActive,
  openPremiumContestPost,
  PREMIUM_CONTEST_BANNER_DISMISSED_STORAGE_KEY,
} from '@/constants/premiumContest'

export default defineComponent({
  name: 'PremiumContestBanner',

  setup() {
    const dismissed = ref(
      localStorage.getItem(PREMIUM_CONTEST_BANNER_DISMISSED_STORAGE_KEY) === 'true',
    )

    const visible = computed(() => isPremiumContestActive() && !dismissed.value)

    const participate = () => {
      openPremiumContestPost()
    }

    const dismiss = () => {
      localStorage.setItem(PREMIUM_CONTEST_BANNER_DISMISSED_STORAGE_KEY, 'true')
      dismissed.value = true
    }

    return {
      visible,
      participate,
      dismiss,
    }
  },
})
</script>

<style scoped>
.premium-contest-banner {
  position: relative;
  z-index: 1;
  border-radius: 0;
  min-height: 96px;
  padding: 20px 24px;
  background: linear-gradient(90deg, #fff8e1 0%, #ffecb3 50%, #ffe082 100%) !important;
  border-bottom: 2px solid #ffb300;
  box-shadow: 0 4px 16px rgba(255, 143, 0, 0.18);
}

:global(.v-theme--dark) .premium-contest-banner {
  background: linear-gradient(90deg, #3e2f00 0%, #5c4300 50%, #7a5900 100%) !important;
  border-bottom-color: #ffb300;
  box-shadow: 0 4px 16px rgba(255, 179, 0, 0.22);
}

.premium-contest-banner__content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  flex-wrap: wrap;
}

.premium-contest-banner__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #fffdf5;
  border: 2px solid #ffb300;
  box-shadow: 0 2px 8px rgba(255, 143, 0, 0.2);
}

:global(.v-theme--dark) .premium-contest-banner__icon-wrap {
  background: #4a3800;
  border-color: #ffb300;
}

.premium-contest-banner__text {
  flex: 1;
  min-width: 220px;
  max-width: 720px;
}

.premium-contest-banner__title {
  display: flex;
  align-items: center;
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 4px;
}

.premium-contest-banner__description {
  font-size: 1rem;
  line-height: 1.5;
  color: rgba(var(--v-theme-on-surface), 0.88);
}

.premium-contest-banner__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
</style>
